import React from 'react';
import styles from './auth-layout.module.scss';

const AuthLayout = ({ children }) => (
  <div className={styles.layout}>{children}</div>
);

export default AuthLayout;
